import { useEffect, useMemo, useRef, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  MotifButton,
  MotifFormField,
  MotifLabel,
  MotifSelect,
  MotifOption,
  MotifAccordion,
  MotifAccordionTrigger,
  MotifAccordionContent,
  MotifAccordionGroup,
} from "@ey-xd/motif-react";
import Input from "../../../common/components/Input/Input";
import "./FindingForm.scss";
import ReportTypeImg from "../../../assets/media/images/report_type.png";
import { MotifInput } from "@ey-xd/motif-react";
import { MAX_INPUT_LENGTH } from "components/Clients/constants";
import { MotifIcon } from "@ey-xd/motif-react";
import { contentIcAdd24px } from "@ey-xd/motif-react/assets/icons";
import { MotifTextArea } from "@ey-xd/motif-react";
import {
  contentIcSave24px,
  fileIcFileDownload24px,
  navigationIcRefresh24px,
  editorIcAttachFile24px,
  actionIcHelpOutline24px,
  alertIcError24px,
  actionIcDelete24px,
  imageIcEdit24px,
  imageIcAddToPhotos24px,
  actionIcDone24px,
  fileIcCloudUpload24px,
  navigationIcClose24px,
} from "@ey-xd/motif-react/assets/icons";
import { MotifFileUploader, MotifFileUploaderItem } from "@ey-xd/motif-react";
import ImagePreview from "../Preview/ImagePreview";
import { MotifModal } from "@ey-xd/motif-react";
import { MotifModalBody } from "@ey-xd/motif-react";
import { MotifModalFooter } from "@ey-xd/motif-react";
import CustomModal from "../Preview/CustomModal";
import { MotifModalHeader } from "@ey-xd/motif-react";
import Button from "@ey-xd/motif-react/components/button";
import AddVunerabilityModal from "../AddVunerabilityModal/AddVunerabilityModal";
import {
  addVulnerabilityName,
  deleteStepAction,
  deleteStepUploadImageAction,
  getVulnerabilityName,
  saveStep,
  setIsVulNameCategoryChanged,
  updateStepAction,
} from "../../../redux/actions/SideBar/sideBar";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import AIGeneratedContent from "../AIGeneratedContent/AIGeneratedContent";
import { ReportGeneratorService } from "services/reportGenerator.service";
import chatTickIcon from "../../../assets/media/images/chat-tick.png";
import { MotifErrorMessage } from "@ey-xd/motif-react";
import {
  FILE_SIZE_ERROR_MSG,
  isMaliciousInput,
  maliciousInputErrorMsg,
  MAX_FILE_SIZE,
  MAX_TEXTAREA_LENGTH,
} from "components/Clients/constants";
import { MotifMessage } from "@ey-xd/motif-react";
import {
  avoidXSSattack,
  avoidXSSattackforStepDescription,
} from "utils/security";
import Toast from "common/components/Toast/Toast";
import MultiPageAdd from "../../../assets/media/images/multiple-pages-add.png";

interface Step {
  encoded_image?: string;
  step_description: string;
  image_caption: string;
  file: File | null;
  isError?: boolean;
  step_id?: number;
  image_link?: string;
  // caption: string;
}

interface UseCaseImage {
  id: string | number;
  file?: File;
  caption: string;
  imageLabel?: string;
  imageLink?: string;
}

interface UseCaseStep {
  id: string | number;
  stepApiId?: number;
  description: string;
  uploadedImages: UseCaseImage[];
  showUploader: boolean;
  isUploadError: boolean;
  isUploading?: boolean;
}

interface UseCaseItem {
  id: string | number;
  useCaseApiId?: string;
  title: string;
  description: string;
  isSaved?: boolean;
  steps: UseCaseStep[];
}

const getUseCasesFromFinding = (finding: any): UseCaseItem[] => {
  const useCases =
    finding?.useCases || finding?.use_cases || finding?.useCaseList || [];
  if (!Array.isArray(useCases) || useCases.length === 0) {
    return [];
  }

  return useCases.map((item: any, itemIndex: number) => {
    const ucName =
      item?.title ||
      item?.name ||
      item?.use_case_name ||
      `Use Case ${itemIndex + 1}`;
    const description =
      item?.description ||
      item?.summary ||
      item?.details ||
      "Link findings and steps to structure this use case.";
    const rawSteps = item?.steps || item?.use_case_steps || item?.useCaseSteps;
    const mappedSteps: UseCaseStep[] =
      Array.isArray(rawSteps) && rawSteps.length > 0
        ? rawSteps.map((step: any, stepIndex: number) => {
            // Map images from API response
            const apiImages: any[] = step?.images || [];
            const uploadedImages: UseCaseImage[] = apiImages.map((img: any) => ({
              id: img.Id || img.id || `img-${stepIndex}-${Math.random()}`,
              caption: img.Caption || img.caption || img.ImageCaption || img.image_caption || "",
              imageLabel: img.ImageLabel || img.image_label || "",
              imageLink: img.ImageLink || img.image_link || "",
            }));

            return {
              id:
                step?.id ||
                step?.step_id ||
                `use-case-${itemIndex + 1}-step-${stepIndex + 1}`,
              stepApiId: step?.step_id || step?.id || undefined,
              description:
                step?.description ||
                step?.step_description ||
                step?.summary ||
                "",
              uploadedImages,
              showUploader: uploadedImages.length === 0,
              isUploadError: false,
              isUploading: false,
            };
          })
        : [];

    return {
      id: item?.id || item?.use_case_id || `use-case-${itemIndex + 1}`,
      useCaseApiId: item?.use_case_id || undefined,
      title: ucName,
      description,
      isSaved: true,
      steps: mappedSteps,
    };
  });
};

type StepPayload = {
  step_number: number;
  step_description: string;
  encoded_image: string | null;
  image_label: any;
  image_caption: string;
  findings_id: any;
} | null;

function debounce(func: any, wait: number) {
  let timeout: any;
  //@ts-ignore
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Memoized TextAreaWithButtons component to prevent focus loss
const TextAreaWithButtons = memo(({
  fieldName,
  label,
  value,
  onChange,
  maxLength,
  disabled,
  className,
  style,
  charCountLabel,
  errorComponent,
  labelComponent,
  correctionData,
  checkingInProgress,
  handleCheckAndCorrect,
  handleAcceptCorrection,
  handleRetryCorrection,
  handleRejectCorrection,
  handleImprovedContentEdit,
  chatTickIcon,
  enableCheckAndCorrect,
}: any) => {
  if (!enableCheckAndCorrect) {
    return (
      <div className="textarea-with-buttons-wrapper">
        <MotifFormField>
          {labelComponent}
          <MotifTextArea
            name={fieldName}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className={className}
            style={style}
            maxLength={maxLength}
          />
          <MotifMessage className="txtAlignRight">
            {charCountLabel}
          </MotifMessage>
          {errorComponent}
        </MotifFormField>
      </div>
    );
  }

  return (
    <div className="textarea-with-buttons-wrapper">
      {/* Blue highlighted container - only visible when correction data exists */}
      {correctionData?.[fieldName] ? (
        <div className="improved-version-container">
          <div className="textarea-button-container">
            <MotifButton
              size="small"
              variant="text"
              onClick={() => handleCheckAndCorrect(fieldName, value)}
              disabled={checkingInProgress?.[fieldName] || !value.trim()}
              title="Check and correct the content"
            >
              {checkingInProgress?.[fieldName] ? (
                <>
                  <MotifIcon
                    src={navigationIcRefresh24px}
                    className="checking-loader"
                    style={{ width: 16, height: 16 }}
                  />
                  <span>Checking...</span>
                </>
              ) : (
                <>
                  <img src={chatTickIcon} style={{ width: 16, height: 16, marginRight: 5 }} />
                  <span> Check & Correct</span>
                </>
              )}
            </MotifButton>
          </div>

          {/* Original Textarea - always visible */}
          <MotifFormField>
            {labelComponent}
            <MotifTextArea
              name={fieldName}
              value={value}
              onChange={onChange}
              disabled={disabled}
              className={className}
              style={style}
              maxLength={maxLength}
            />
            <MotifMessage className="txtAlignRight">
              {charCountLabel}
            </MotifMessage>
            {errorComponent}
          </MotifFormField>

          {/* Action Buttons */}
          <div className="improved-actions-container">
            <MotifButton
              size="small"
              variant="secondary"
              onClick={() => handleAcceptCorrection(fieldName)}
              title="Accept this correction"
              className="action-btn-square"
            >
              <MotifIcon src={actionIcDone24px} style={{ width: 24, height: 24 }} />
            </MotifButton>
            <MotifButton
              size="small"
              variant="secondary"
              onClick={() => handleRetryCorrection(fieldName)}
              disabled={checkingInProgress?.[fieldName]}
              title="Retry correction"
              className="action-btn-square"
            >
              <MotifIcon src={navigationIcRefresh24px} style={{ width: 24, height: 24 }} />
            </MotifButton>
            <MotifButton
              size="small"
              variant="secondary"
              onClick={() => handleRejectCorrection(fieldName)}
              title="Reject this correction"
              className="action-btn-square"
            >
              <MotifIcon src={navigationIcClose24px} style={{ width: 24, height: 24 }} />
            </MotifButton>
          </div>

          {/* Improved Version Header and Textarea */}
          <div className="improved-version-header">
            <span className="improved-title">
              <span className="improved-title-line" aria-hidden="true" />
              Improved Version
              <span className="improved-title-line" aria-hidden="true" />
            </span>
          </div>
          <div className="improved-textarea-wrapper">
            <MotifTextArea
              value={correctionData?.[fieldName]?.corrected || ''}
              onChange={(e: any) => handleImprovedContentEdit(fieldName, e)}
              disabled={false}
              maxLength={maxLength}
              className="improved-textarea"
              style={{ whiteSpace: "pre-wrap", backgroundColor: "#F5F9FF" }}
            />
            <MotifMessage className="txtAlignRight">
              {`${correctionData?.[fieldName]?.corrected?.length || 0}/${maxLength} characters`}
            </MotifMessage>
          </div>
        </div>
      ) : (
        <>
          <div className="textarea-button-container">
            <MotifButton
              size="small"
              variant="text"
              onClick={() => handleCheckAndCorrect(fieldName, value)}
              disabled={checkingInProgress?.[fieldName] || !value.trim()}
              title="Check and correct the content"
            >
              {checkingInProgress?.[fieldName] ? (
                <>
                  <MotifIcon
                    src={navigationIcRefresh24px}
                    className="checking-loader"
                    style={{ width: 16, height: 16 }}
                  />
                  <span>Checking...</span>
                </>
              ) : (
                <>
                  <img src={chatTickIcon} style={{ width: 16, height: 16, marginRight: 5 }} />
                  <span> Check & Correct</span>
                </>
              )}
            </MotifButton>
          </div>

          {/* Original Textarea - always visible */}
          <MotifFormField>
            {labelComponent}
            <MotifTextArea
              name={fieldName}
              value={value}
              onChange={onChange}
              disabled={disabled}
              className={className}
              style={style}
              maxLength={maxLength}
            />
            <MotifMessage className="txtAlignRight">
              {charCountLabel}
            </MotifMessage>
            {errorComponent}
          </MotifFormField>
        </>
      )}
    </div>
  );
});

const FindingForm = ({
  handleGenerateFinding,
  handleUpdateFinding,
  index,
  status,
  finding,
  showLoader,
  isViewMode = false,
}: any) => {
  const vul_category_list = useSelector(
    (state: any) => state.sideBar.vul_category_list
  );
  const vul_name_list = useSelector(
    (state: any) => state.sideBar.vul_name_list || {}
  );
  const stepUploadError = useSelector(
    (state: any) => state.sideBar.stepUploadError
  );
  const stepDeleteError = useSelector(
    (state: any) => state.sideBar.stepDeleteError
  );
  const isVulCategoryNameChanged =
    useSelector((state: any) => state?.sideBar?.isVulCategoryNameChanged) ||
    false;
  const currentTenant = useSelector(
    (state: any) => state?.user?.currentTenant
  );
  const isAiaTenant =
    (currentTenant?.TenantName || "").toLowerCase() === "aia";
  const isCheckAndCorrectEnabled =
    (currentTenant?.TenantName || "").toLowerCase() === "allianz";
  const dispatch = useDispatch();
  const [showSpinner, setShowSpinner] = useState(false);
  const [isNewVuln, setIsNewVuln] = useState(false);
const [addVulError, setAddVulError] = useState<string | null>(null);
const [vulnerabilityDuplicateErrMsg, setvulnerabilityDuplicateErrMsg] = useState<boolean>(true);
const [isFirstDropdownOpen, setIsFirstDropdownOpen] = useState(false);
  let formRef = useRef<any>(null);
  let aiGeneratedContent = {
    ...finding.aiGeneratedContent,
    llm_reason:
      finding?.Reason || finding?.aiGeneratedContent?.llm_reason || "",
      baseline_cvss_vector: finding?.baseline_cvss_vector || "",
      cvss_score_changed: finding?.cvss_score_changed || false,
  };
  const defaultFormdata = {
    id: finding.finding_id,
    vulnerabilityCategory: finding.vul_category || "",
    vulnerabilityName: finding.vul_name || "",
    port: finding.port || "",
    cwe: finding.cwe || "",
    likelihoodType: finding.vul_likelyhood_desc || "",
    vulnerabilityDescription: finding.vul_desc || "",
    affectedAssets: finding.vul_assets_impacted || "",
    stepsToReproduce: finding.steps as Step[],
    impact: finding.vul_impact || "",
    isModified: false,
    aiGeneratedContent: aiGeneratedContent,
    isLoaded: finding.isLoaded || false,
    baseline_cvss_vector: finding?.aiGeneratedContent?.baseline_cvss_vector || "",
    cvss_score_changed: finding?.cvss_score_changed || false,
    // llm_reason: finding?.Reason || finding?.aiGeneratedContent?.llm_reason || "", // need to check
  };
  // console.log(finding?.aiGeneratedContent)

  const defaultSteps: Step[] = [
    {
      step_description: "",
      file: null,
      image_caption: "",
      // caption: ""
    },
  ];
  const [steps, setSteps] = useState<Step[]>(defaultSteps);
  const [formData, setFormData] = useState(defaultFormdata);
  const [vulModal, setVulModal] = useState(false);
  const formEnabled = isViewMode;

  const [preview, setPreview] = useState(null);
  const [toastData, setToastData] = useState<any>({});
  const [toastVisible, setToastVisible] = useState<boolean>(false);
  const [correctionData, setCorrectionData] = useState<{ [key: string]: any }>({});
  const [checkingInProgress, setCheckingInProgress] = useState<{ [key: string]: boolean }>({});
  const [useCases, setUseCases] = useState<UseCaseItem[]>(
    getUseCasesFromFinding(finding)
  );
  const [openUseCaseIndex, setOpenUseCaseIndex] = useState<number>(-1);
  const [editableUseCaseIndex, setEditableUseCaseIndex] = useState<number | null>(null);
  const [isSavingUseCaseIndex, setIsSavingUseCaseIndex] = useState<number | null>(null);

  const handlePostResponse = (
    header: string,
    message: string,
    variant: string
  ) => {
    setShowSpinner(false);
    setToastData({ header, message, variant });
    setToastVisible(true);
    variant !== "error" &&
      setTimeout(() => {
        setToastVisible(false);
      }, 5000);
  };

  const handleCheckAndCorrect = async (fieldName: string, text: string): Promise<void> => {
    if (!isCheckAndCorrectEnabled) {
      return;
    }

    if (!text.trim()) {
      handlePostResponse("Error", "Text cannot be empty", "error");
      return;
    }

    setCheckingInProgress((prev) => ({
      ...prev,
      [fieldName]: true,
    }));

    try {
      const response = await ReportGeneratorService.checkAndCorrectText({
        content: text,
      });

      if (!response?.hasErrors && (response.value as any)) {
        const correctedText = (response.value as any).refined_content || (response.value as any).corrected_text || (response.value as any).correctedText || text;
        setCorrectionData((prev) => ({
          ...prev,
          [fieldName]: {
            original: text,
            corrected: correctedText,
            status: "pending_review",
          },
        }));
        handlePostResponse(
          "Success",
          "Text checked. Review the improved version below.",
          "success"
        );
      } else {
        const errorMsg = response?.errors?.[0]?.message || "Failed to check and correct text";
        handlePostResponse(
          "Error",
          errorMsg,
          "error"
        );
      }
    } catch (error: any) {
      handlePostResponse(
        "Error",
        error?.message || "Error checking and correcting text",
        "error"
      );
    } finally {
      setCheckingInProgress((prev) => ({
        ...prev,
        [fieldName]: false,
      }));
    }
  };

  const handleAcceptCorrection = (fieldName: string) => {
    const correctionInfo = correctionData?.[fieldName];
    if (correctionInfo) {
      // Update the form data with corrected text
      setFormData((prev) => ({
        ...prev,
        [fieldName]: correctionInfo.corrected,
        isModified: true,
      }));

      // Clear correction data and show success
      setCorrectionData((prev) => {
        const newData = { ...prev };
        delete newData[fieldName];
        return newData;
      });

      handlePostResponse(
        "Success",
        "Correction accepted and applied",
        "success"
      );
    }
  };

  const handleRejectCorrection = (fieldName: string) => {
    setCorrectionData((prev) => {
      const newData = { ...prev };
      delete newData[fieldName];
      return newData;
    });
    handlePostResponse("Info", "Correction rejected", "info");
  };

  const handleRetryCorrection = (fieldName: string) => {
    const correctionInfo = correctionData?.[fieldName];
    if (correctionInfo) {
      handleCheckAndCorrect(fieldName, correctionInfo.original);
    }
  };

  const handleImprovedContentEdit = (fieldName: string, e: any) => {
    const newValue = e?.target?.value ?? "";
    
    setCorrectionData((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev?.[fieldName],
        corrected: newValue,
      },
    }));
  };

  useEffect(() => {
    setFormData({ ...formData, aiGeneratedContent: aiGeneratedContent });
  }, [finding.aiGeneratedContent]);

  useEffect(() => {
    setSteps(finding.steps);
  }, [finding.isLoaded]);

  useEffect(() => {
    setUseCases(getUseCasesFromFinding(finding));
    setOpenUseCaseIndex(-1);
    setEditableUseCaseIndex(null);
  }, [finding]);

  const toBase64 = (file: any) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const getStepPayload = async (
    index: number,
    file: any,
    desc: string,
    imageCaption: string
  ) => {
    let encoded_image: string = "";

    //@ts-ignore
    encoded_image = await toBase64(file);

    const payload = {
      step_number: index + 1,
      step_description: desc,
      encoded_image: encoded_image
        ? encoded_image.replace(/^data:image\/[a-z]+;base64,/, "")
        : null,
      image_label: file?.name,
      image_caption: imageCaption,
      findings_id: finding.finding_id,
    };
    return payload;
  };

  const uploadFile = async (
    file: any,
    index: number,
    payloadEdit: { step_id: number | undefined }
  ) => {
    const allowedExtensions: (".png" | ".jpeg" | ".jpg")[] = [
      ".png",
      ".jpeg",
      ".jpg",
    ];

    try {
      if (!file || file.length === 0) {
        alert("No files selected!");
        return;
      }
      for (let i = 0; i < file.length; i++) {
        const file1: File = file[i];
        const fileName: string = file1.name.toLowerCase();
        const fileExtension: string = fileName.substring(
          fileName.lastIndexOf(".")
        ) as string;

        if (
          !allowedExtensions.includes(
            fileExtension as ".png" | ".jpeg" | ".jpg"
          )
        ) {
          alert(
            `Invalid file Extension: Only .png, .jpeg, and .jpg files are allowed.`
          );
          return; // Exit the function if an invalid file is detected
        }
      }

      const isError = file[0].size > 1024 * 1024; // 1MB = 1024 * 1024 bytes

      if (isError) {
        handlePostResponse("Error", "File size should not exceed 1MB", "error");
        return;
      }

      if (file?.[0] !== null) {
        const payload = await getStepPayload(
          index,
          file?.[0],
          steps[index].step_description.trim(),
          steps[index]?.image_caption.trim()
        );
        if (payloadEdit?.step_id) {
          const constructedPayload = {
            step_id: payloadEdit.step_id,
            data: {
              EncodedImage: payload.encoded_image,
              ImageLabel: payload.image_label,
              Id: payloadEdit.step_id,
              StepNumber: payload.step_number,
              FindingId: finding.finding_id,
            },
          };
          dispatch(updateStepAction(constructedPayload)).then(
            (response: any) => {
              let updatedSteps = [...steps];
              updatedSteps[index] = {
                ...updatedSteps[index],
                ...response,
              };
              setSteps(updatedSteps);
              setFormData({
                ...formData,
                isModified: true,
                stepsToReproduce: updatedSteps,
              });
              if (stepUploadError) {
                handlePostResponse(
                  "Error",
                  "Failed to upload image. Please try again or reload application",
                  "error"
                );
              } else {
                handlePostResponse(
                  "Success",
                  "Image uploaded successfully. Please update finding",
                  "success"
                );
              }
            }
          );
        } else {
          dispatch(
            saveStep({ ...payload, finding_id: finding.finding_id })
          ).then((response: any) => {
            let updatedSteps = [...steps];
            updatedSteps[index] = {
              ...updatedSteps[index],
              file: file[0].size > 1000000 ? null : file[0],
              isError,
              ...response,
            };
            setSteps(updatedSteps);
            setFormData({
              ...formData,
              isModified: true,
              stepsToReproduce: updatedSteps,
            });

            handlePostResponse(
              "Success",
              "Image uploaded successfully. Please update finding",
              "success"
            );
          });
        }
      }
    } catch (err) {
      console.log(err);
      alert("An unexpected error occurred."); // Optional: Alert for unexpected errors
    }
  };

  const addSteps = async () => {
    setSteps([
      ...steps,
      {
        step_description: "",
        file: null,
        image_caption: "",
        // caption:""
      },
    ]);
  };

  const removeFile = (index: number, stepId: number | undefined) => {
    dispatch(
      deleteStepUploadImageAction({
        step_id: stepId,
        finding_id: finding.finding_id,
      })
    ).then(() => {
      setSteps((prevSteps) => {
        const updatedSteps = [...prevSteps];
        // @ts-ignore
        const { encoded_image, image_link, image_label, ...rest } =
          updatedSteps[index];
        updatedSteps[index] = {
          ...rest,
          file: null,
        };
        // Update formData with the new steps
        setFormData((prevFormData: any) => ({
          ...prevFormData,
          isModified: true,
          stepsToReproduce: updatedSteps,
        }));
        return updatedSteps;
      });
      if (stepDeleteError) {
        handlePostResponse(
          "Error",
          "Failed to remove image. Please try again or reload application",
          "error"
        );
        return;
      }
      handlePostResponse(
        "Success",
        "Image removed successfully. Please save the report",
        "success"
      );
    });
  };

  const debouncedSaveStepRef = useRef<any>([]);

  const updateSteps = (e: any, index: number, field: any) => {
    if (field === "step_description") {
      e = avoidXSSattackforStepDescription(e);
    } else {
      e = avoidXSSattack(e);
    }
    let value = e?.target?.value;
    let updatedSteps = [...steps];
    updatedSteps[index] = {
      ...updatedSteps[index],
      [field]: value,
    };
    setSteps(updatedSteps);
    setFormData({
      ...formData,
      isModified: true,
      stepsToReproduce: updatedSteps,
    });
    // Call the debounced function
    if (debouncedSaveStepRef.current[index]) {
      debouncedSaveStepRef.current[index](value);
    }
  };
  const onDeleteStep = (index: number) => {
    setSteps((prevSteps) => {
      const updatedSteps = [...prevSteps];
      updatedSteps.splice(index, 1);

      // Update formData with the new steps
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        isModified: true,
        stepsToReproduce: updatedSteps,
      }));
      return updatedSteps;
    });
  };

  const handleDeleteStep = (index: number, payload: any) => {
    if (payload.step_id) {
      dispatch(deleteStepAction(payload)).then(() => {
        onDeleteStep(index);
        handlePostResponse(
          "Success",
          "Steps deleted successfully. Please save the report",
          "success"
        );
      });
    } else {
      onDeleteStep(index);
      handlePostResponse(
        "Success",
        "Steps deleted successfully. Please save the report",
        "success"
      );
    }
  };

  const previewImage = (file: any) => {
    setPreview(file);
  };

  const handleChange = (e: any, name: any) => {
    let value = "";
    if (typeof e === "object") {
      if (e?.target?.value) {
        e = avoidXSSattack(e);
      }
      value = e?.target?.value;
    } else {
      value = e;
    }
    if (name === "vulnerabilityCategory") {
      setShowSpinner(true);
      dispatch(
        getVulnerabilityName({
          vul_category: value,
        })
      ).then(() => {
        if (formData.isLoaded && value !== finding.Category) {
          dispatch(setIsVulNameCategoryChanged(true));
          setShowSpinner(false);
          return;
        } else {
          dispatch(setIsVulNameCategoryChanged(false));
        }
        setShowSpinner(false);
      });
      setFormData({
        ...formData,
        isModified: true,
        vulnerabilityName: "",
        vulnerabilityCategory: value,
      });
    } else {
      setFormData({
        ...formData,
        isModified: true,
        [name]: value,
      });
    }
  };

  const handleVulNamePopulate = () => {
    setShowSpinner(true);
    dispatch(
      getVulnerabilityName({
        vul_category: formData.vulnerabilityCategory,
      })
    ).then(() => setShowSpinner(false));
  };

  const onAddVulnerabilityName = (vulnName: any) => {
    setShowSpinner(true);
    setvulnerabilityDuplicateErrMsg(true);
    dispatch(
      addVulnerabilityName({
        vul_name: vulnName,
        vul_category: formData.vulnerabilityCategory,
      })
    ).then(() => {
      // Fetch the updated vulnerability name list after adding
      dispatch(
        getVulnerabilityName({
          vul_category: formData.vulnerabilityCategory,
        })
      ).then(() => {
        setShowSpinner(false)
        handleVisibility();
        setToastVisible(false);
        // setvulnerabilityDuplicateErrMsg(true);
      })
      // Handling the error case
    }).catch((err: any) => {
      if(err?.message?.includes("Duplicate Vulnerability Name Found")) {
      setvulnerabilityDuplicateErrMsg(false);
      setShowSpinner(false)
      // // setAddVulError(err.message);
      // setToastData({
      //   header: "Error",
      //   message: "Duplicate Vulnerability Name Found",
      //   variant: "error"
      // });
      // setToastVisible(true);
      // setTimeout(() => {
      //   setToastVisible(false);
      // }, 5000); // Hide toast after 5 seconds
      handleAddVulnerabilityName();
    } else {
      handleVisibility();
      setToastVisible(false);
      setShowSpinner(false)
    }
    })
  };

  const populateData = (valName: any) => {
    ReportGeneratorService.getDefaultVulnerabilityDetails({
      Name: valName,
      Category: formData.vulnerabilityCategory,
    }).then((res: any) => {
      const details = (res?.value?.data as any[])[0];
      if(details && Object.keys(details).length >0){
      setFormData({
        ...formData,
        vulnerabilityDescription: details?.vulnerability_description,
        likelihoodType: details?.likelihood,
        impact: details?.impact,
        vulnerabilityName: valName,
        cwe: details?.cwe || "",
        aiGeneratedContent: {
          ...details?.ai_generated_content,
          cvss_vector: details?.ai_generated_content?.cvss_string,
          cvss_severity: details?.ai_generated_content?.severity.replace(
            "\n",
            ""
          ),
        },
        //isLoaded: true,
        isModified: true,
      });
    }else{
      setIsNewVuln(true);
    }
    });
  };

  const onSelecrVulnerabilityName = (val: any) => {
    setFormData({
      ...formData,
      vulnerabilityName: val,
    });
    populateData(val);
  };

  const validateCVSS = (cvssString: string) => {
    const regex =
      /^CVSS:3\.0\/AV:[NALP]\/AC:[LH]\/PR:[NLH]\/UI:[NR]\/S:[UC]\/C:[NLH]\/I:[NLH]\/A:[NLH]$/;
    return regex.test(cvssString);
  };

  const handleAIGeneratedDataChange = async (e: any, field: any) => {
    let value = "";
    let isCVSS_valid = false;
    if (field === "cvss_vector") {
      if (!validateCVSS(e.target.value)) {
        isCVSS_valid = true;
      }
    }

    if (typeof e === "object") {
      value = e?.target?.value;
    } else {
      value = e;
    }
    await setFormData({
      ...formData,
      isModified: true,
      aiGeneratedContent: {
        ...formData.aiGeneratedContent,
        cvssValidation: isCVSS_valid,
        [field]: value,
      },
    });
  };

  const handleAddVulnerabilityName = () => {
    const vulnElement = document.getElementById("vulnerabilityName-select");
    if (vulnElement) {
      vulnElement.style.display = "none";
    }
    setVulModal(true);
  };

  const handleVisibility = () => {
    const vulnElement = document.getElementById("vulnerabilityName-select");
    if (vulnElement) {
      vulnElement.style.display = "block";
    }
    setVulModal(false);
  };

  const handleAddUseCase = () => {
    const newUseCase: UseCaseItem = {
      id: `use-case-${Date.now()}`,
      title: `Use Case ${useCases.length + 1}`,
      description: "Link findings and steps to structure this use case.",
      isSaved: false,
      steps: [],
    };

    setUseCases((prevUseCases) => [...prevUseCases, newUseCase]);
    setOpenUseCaseIndex(useCases.length);
    setEditableUseCaseIndex(useCases.length);
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      isModified: true,
    }));
  };

  const handleSaveUseCase = async (useCaseIndex: number) => {
    if (!isAiaTenant) {
      return;
    }
    const useCase = useCases[useCaseIndex];
    if (!useCase.title.trim()) {
      handlePostResponse("Error", "Use case name cannot be empty.", "error");
      return;
    }
    setIsSavingUseCaseIndex(useCaseIndex);
    try {
      const response = await ReportGeneratorService.createUseCase({
        finding_id: finding.finding_id,
        use_case_name: useCase.title.trim(),
      });
      if (response?.hasErrors) {
        const errMsg =
          response?.errors?.[0]?.message ||
          "Failed to save use case. Please try again.";
        handlePostResponse("Error", errMsg, "error");
        return;
      }
      const useCaseApiId =
        (response?.value as any)?.use_case_id ||
        (response?.value as any)?.data?.use_case_id ||
        `UC-${Date.now()}`;
      setUseCases((prevUseCases) => {
        const updatedUseCases = [...prevUseCases];
        updatedUseCases[useCaseIndex] = {
          ...updatedUseCases[useCaseIndex],
          isSaved: true,
          useCaseApiId,
        };
        return updatedUseCases;
      });
      setEditableUseCaseIndex(null);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        isModified: true,
      }));
      handlePostResponse("Success", "Use case saved successfully.", "success");
    } catch (err: any) {
      handlePostResponse(
        "Error",
        err?.message || "Failed to save use case. Please try again.",
        "error"
      );
    } finally {
      setIsSavingUseCaseIndex(null);
    }
  };

  const handleUpdateUseCase = async (useCaseIndex: number) => {
    if (!isAiaTenant) return;
    const useCase = useCases[useCaseIndex];
    if (!useCase.title.trim()) {
      handlePostResponse("Error", "Use case name cannot be empty.", "error");
      return;
    }
    if (!useCase.useCaseApiId) {
      handlePostResponse("Error", "Use case ID is missing.", "error");
      return;
    }
    setIsSavingUseCaseIndex(useCaseIndex);
    try {
      const response = await ReportGeneratorService.updateUseCase(
        useCase.useCaseApiId,
        { use_case_name: useCase.title.trim() }
      );
      if (response?.hasErrors) {
        const errMsg =
          response?.errors?.[0]?.message ||
          "Failed to update use case. Please try again.";
        handlePostResponse("Error", errMsg, "error");
        return;
      }
      setEditableUseCaseIndex(null);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        isModified: true,
      }));
      handlePostResponse("Success", "Use case updated successfully.", "success");
    } catch (err: any) {
      handlePostResponse(
        "Error",
        err?.message || "Failed to update use case. Please try again.",
        "error"
      );
    } finally {
      setIsSavingUseCaseIndex(null);
    }
  };

  const handleUseCaseTitleChange = (value: string, useCaseIndex: number) => {    setUseCases((prevUseCases) => {
      const updatedUseCases = [...prevUseCases];
      updatedUseCases[useCaseIndex] = {
        ...updatedUseCases[useCaseIndex],
        title: value,
      };
      return updatedUseCases;
    });
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      isModified: true,
    }));
  };

  const handleUseCaseStepDescriptionChange = (
    value: string,
    useCaseIndex: number,
    stepIndex: number
  ) => {
    setUseCases((prevUseCases) => {
      const updatedUseCases = [...prevUseCases];
      const selectedUseCase = updatedUseCases[useCaseIndex];
      const updatedSteps = [...selectedUseCase.steps];
      updatedSteps[stepIndex] = {
        ...updatedSteps[stepIndex],
        description: value,
      };
      updatedUseCases[useCaseIndex] = {
        ...selectedUseCase,
        description: stepIndex === 0 ? value : selectedUseCase.description,
        steps: updatedSteps,
      };
      return updatedUseCases;
    });
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      isModified: true,
    }));
  };

  const handleUseCaseImageCaptionChange = (
    value: string,
    useCaseIndex: number,
    stepIndex: number,
    imageIndex: number
  ) => {
    setUseCases((prevUseCases) => {
      const updatedUseCases = [...prevUseCases];
      const selectedUseCase = updatedUseCases[useCaseIndex];
      const updatedSteps = [...selectedUseCase.steps];
      const updatedImages = [...updatedSteps[stepIndex].uploadedImages];
      updatedImages[imageIndex] = { ...updatedImages[imageIndex], caption: value };
      updatedSteps[stepIndex] = { ...updatedSteps[stepIndex], uploadedImages: updatedImages };
      updatedUseCases[useCaseIndex] = { ...selectedUseCase, steps: updatedSteps };
      return updatedUseCases;
    });
    setFormData((prevFormData: any) => ({ ...prevFormData, isModified: true }));
  };

  const getFilesFromUploadPayload = (payload: any): File[] => {
    if (!payload) {
      return [];
    }
    if (Array.isArray(payload)) {
      return payload;
    }
    if (payload instanceof FileList) {
      return Array.from(payload);
    }
    if (payload?.dataTransfer?.files) {
      return Array.from(payload.dataTransfer.files);
    }
    if (payload?.target?.files) {
      return Array.from(payload.target.files);
    }
    return [];
  };

  const handleUseCaseScreenshotUpload = async (
    payload: any,
    useCaseIndex: number,
    stepIndex: number
  ) => {
    const uploadedFiles = getFilesFromUploadPayload(payload);
    const file = uploadedFiles?.[0];
    if (!file) {
      return;
    }

    const validExtension = [".png", ".jpg", ".jpeg"].some((ext) =>
      file.name.toLowerCase().endsWith(ext)
    );

    if (!validExtension) {
      handlePostResponse(
        "Error",
        "Invalid file type. Only PNG and JPG files are allowed.",
        "error"
      );
      return;
    }

    if (file.size > 500 * 1024) {
      setUseCases((prevUseCases) => {
        const updatedUseCases = [...prevUseCases];
        const selectedUseCase = updatedUseCases[useCaseIndex];
        const updatedSteps = [...selectedUseCase.steps];
        updatedSteps[stepIndex] = { ...updatedSteps[stepIndex], isUploadError: true };
        updatedUseCases[useCaseIndex] = { ...selectedUseCase, steps: updatedSteps };
        return updatedUseCases;
      });
      handlePostResponse("Error", "File size should not exceed 500KB", "error");
      return;
    }

    if (!isAiaTenant) {
      return;
    }

    const useCase = useCases[useCaseIndex];
    const step = useCase.steps[stepIndex];

    // Mark step as uploading
    setUseCases((prevUseCases) => {
      const updatedUseCases = [...prevUseCases];
      const selectedUseCase = updatedUseCases[useCaseIndex];
      const updatedSteps = [...selectedUseCase.steps];
      updatedSteps[stepIndex] = { ...updatedSteps[stepIndex], isUploading: true, isUploadError: false };
      updatedUseCases[useCaseIndex] = { ...selectedUseCase, steps: updatedSteps };
      return updatedUseCases;
    });

    try {
      const base64String = await toBase64(file) as string;
      const encodedImage = base64String.replace(/^data:image\/[a-z]+;base64,/, "");

      let response: any;
      if (step.stepApiId) {
        // Step already exists in DB � update with new image
        response = await ReportGeneratorService.updateStep({
          step_id: String(step.stepApiId),
          data: {
            encoded_image: encodedImage,
            image_label: file.name,
          },
        });
      } else {
        // First image for this step � create step
        response = await ReportGeneratorService.saveStep({
          encoded_image: encodedImage,
          findings_id: String(finding.finding_id),
          image_caption: "",
          image_label: file.name,
          step_description: step.description || "",
          step_number: stepIndex + 1,
          use_case_id: useCase.useCaseApiId,
        });
      }

      if (response?.hasErrors) {
        const errMsg =
          response?.errors?.[0]?.message ||
          "Failed to upload image. Please try again.";
        setUseCases((prevUseCases) => {
          const updatedUseCases = [...prevUseCases];
          const selectedUseCase = updatedUseCases[useCaseIndex];
          const updatedSteps = [...selectedUseCase.steps];
          updatedSteps[stepIndex] = { ...updatedSteps[stepIndex], isUploading: false, isUploadError: true };
          updatedUseCases[useCaseIndex] = { ...selectedUseCase, steps: updatedSteps };
          return updatedUseCases;
        });
        handlePostResponse("Error", errMsg, "error");
        return;
      }

      const responseData = response?.value as any;
      const stepApiId = responseData?.step_id || step.stepApiId;
      const apiImages: any[] = responseData?.images || [];

      // PUT returns the full images array; POST returns only new images
      setUseCases((prevUseCases) => {
        const updatedUseCases = [...prevUseCases];
        const selectedUseCase = updatedUseCases[useCaseIndex];
        const updatedSteps = [...selectedUseCase.steps];
        const existingImages = updatedSteps[stepIndex]?.uploadedImages || [];
        const allImages: UseCaseImage[] = apiImages.map((img: any) => {
          const imgId = img.Id || img.id;
          const existingImg = existingImages.find((ei) => ei.id === imgId);
          return {
            id: imgId || `img-${Date.now()}-${Math.random()}`,
            caption: existingImg ? existingImg.caption : "",
            imageLabel: img.ImageLabel || file.name,
            imageLink: img.ImageLink || "",
          };
        });
        updatedSteps[stepIndex] = {
          ...updatedSteps[stepIndex],
          stepApiId,
          uploadedImages: step.stepApiId ? allImages : [...updatedSteps[stepIndex].uploadedImages, ...allImages],
          showUploader: false,
          isUploadError: false,
          isUploading: false,
        };
        updatedUseCases[useCaseIndex] = { ...selectedUseCase, steps: updatedSteps };
        return updatedUseCases;
      });
      setFormData((prevFormData: any) => ({ ...prevFormData, isModified: true }));
      handlePostResponse("Success", "Image uploaded successfully.", "success");
    } catch (err: any) {
      setUseCases((prevUseCases) => {
        const updatedUseCases = [...prevUseCases];
        const selectedUseCase = updatedUseCases[useCaseIndex];
        const updatedSteps = [...selectedUseCase.steps];
        updatedSteps[stepIndex] = { ...updatedSteps[stepIndex], isUploading: false, isUploadError: true };
        updatedUseCases[useCaseIndex] = { ...selectedUseCase, steps: updatedSteps };
        return updatedUseCases;
      });
      handlePostResponse(
        "Error",
        err?.message || "Failed to upload image. Please try again.",
        "error"
      );
    }
  };

  const handleUseCaseImageRemove = async (
    useCaseIndex: number,
    stepIndex: number,
    imageIndex: number
  ) => {
    const step = useCases[useCaseIndex]?.steps?.[stepIndex];
    const image = step?.uploadedImages?.[imageIndex];
    if (image?.imageLink && step?.stepApiId) {
      try {
        const response = await ReportGeneratorService.deleteStepUploadImage({
          image_id: image.id,
          step_id: String(step.stepApiId),
        });
        if (response?.hasErrors) {
          handlePostResponse(
            "Error",
            response?.errors?.[0]?.message || "Failed to delete image. Please try again.",
            "error"
          );
          return;
        }
      } catch (err: any) {
        handlePostResponse(
          "Error",
          err?.message || "Failed to delete image. Please try again.",
          "error"
        );
        return;
      }
    }
    setUseCases((prevUseCases) => {
      const updatedUseCases = [...prevUseCases];
      const selectedUseCase = updatedUseCases[useCaseIndex];
      const updatedSteps = [...selectedUseCase.steps];
      const updatedImages = updatedSteps[stepIndex].uploadedImages.filter(
        (_img, idx) => idx !== imageIndex
      );
      updatedSteps[stepIndex] = { ...updatedSteps[stepIndex], uploadedImages: updatedImages, showUploader: updatedImages.length === 0 };
      updatedUseCases[useCaseIndex] = { ...selectedUseCase, steps: updatedSteps };
      return updatedUseCases;
    });
    setFormData((prevFormData: any) => ({ ...prevFormData, isModified: true }));
  };

  const handleShowUseCaseUploader = (useCaseIndex: number, stepIndex: number) => {
    setUseCases((prevUseCases) => {
      const updatedUseCases = [...prevUseCases];
      const selectedUseCase = updatedUseCases[useCaseIndex];
      const updatedSteps = [...selectedUseCase.steps];
      updatedSteps[stepIndex] = { ...updatedSteps[stepIndex], showUploader: true, isUploadError: false };
      updatedUseCases[useCaseIndex] = { ...selectedUseCase, steps: updatedSteps };
      return updatedUseCases;
    });
  };

  const getUseCaseFileSizeLabel = (file?: File | null) => {
    if (!file?.size) {
      return "";
    }
    if (file.size < 1024) {
      return `${file.size} B`;
    }
    const sizeInKb = file.size / 1024;
    return `${sizeInKb.toFixed(sizeInKb >= 100 ? 0 : 1)} KB`;
  };

  const handleAddUseCaseStep = (useCaseIndex: number) => {
    setUseCases((prevUseCases) => {
      const updatedUseCases = [...prevUseCases];
      const selectedUseCase = updatedUseCases[useCaseIndex];
      const newStep = {
        id: `${selectedUseCase.id}-step-${selectedUseCase.steps.length + 1}-${Date.now()}`,
        description: "",
        uploadedImages: [],
        showUploader: true,
        isUploadError: false,
      };
      updatedUseCases[useCaseIndex] = {
        ...selectedUseCase,
        steps: [...selectedUseCase.steps, newStep],
      };
      return updatedUseCases;
    });
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      isModified: true,
    }));
  };

  const handleDeleteUseCaseStep = async (useCaseIndex: number, stepIndex: number) => {
    const step = useCases[useCaseIndex]?.steps?.[stepIndex];
    const hasImageData = step?.uploadedImages && step.uploadedImages.length > 0;
    if (step?.stepApiId && hasImageData) {
      try {
        const response = await ReportGeneratorService.deleteStep({ step_id: String(step.stepApiId) });
        if (response?.hasErrors) {
          handlePostResponse(
            "Error",
            response?.errors?.[0]?.message || "Failed to delete step. Please try again.",
            "error"
          );
          return;
        }
      } catch (err: any) {
        handlePostResponse(
          "Error",
          err?.message || "Failed to delete step. Please try again.",
          "error"
        );
        return;
      }
    }
    setUseCases((prevUseCases) => {
      const updatedUseCases = [...prevUseCases];
      const selectedUseCase = updatedUseCases[useCaseIndex];
      const updatedSteps = selectedUseCase.steps.filter(
        (_step, idx) => idx !== stepIndex
      );
      updatedUseCases[useCaseIndex] = {
        ...selectedUseCase,
        description: updatedSteps[0]?.description || "",
        steps: updatedSteps,
      };
      return updatedUseCases;
    });
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      isModified: true,
    }));
  };

  const handleDeleteUseCase = async (useCaseIndex: number) => {
    const useCase = useCases[useCaseIndex];
    if (useCase?.useCaseApiId) {
      try {
        await ReportGeneratorService.deleteUseCase(useCase.useCaseApiId);
      } catch (error) {
        console.error("Failed to delete use case", error);
        return;
      }
    }
    setUseCases((prevUseCases) => {
      const updatedUseCases = prevUseCases.filter(
        (_useCase, idx) => idx !== useCaseIndex
      );
      setOpenUseCaseIndex((prevOpenIndex) => {
        if (prevOpenIndex === useCaseIndex) {
          return -1;
        }
        if (prevOpenIndex > useCaseIndex) {
          return prevOpenIndex - 1;
        }
        return prevOpenIndex;
      });
      setEditableUseCaseIndex((prevEditableIndex) => {
        if (prevEditableIndex === useCaseIndex) {
          return null;
        }
        if (
          prevEditableIndex !== null &&
          prevEditableIndex > useCaseIndex
        ) {
          return prevEditableIndex - 1;
        }
        return prevEditableIndex;
      });
      return updatedUseCases;
    });
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      isModified: true,
    }));
  };

  const handleFocus = () => {
    // Find the button using its class
    setIsFirstDropdownOpen(!isFirstDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (formRef.current && !formRef.current.contains(event.target)) {
        setIsFirstDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isEnableFindingBtn = useMemo(() => {
    const { isLoaded, isModified, baseline_cvss_vector, cvss_score_changed, ...rest } = formData;

    if (isAiaTenant) {
      return !!(rest.vulnerabilityCategory && rest.vulnerabilityName);
    }

    const isValidFormData = Object.entries(rest).every(([key, value]) => {
      if (["port", "cwe"].includes(key)) {
        return true;
      }
      if (key === "aiGeneratedContent") {
        const { cvssValidation, cvss_vector, cvss_severity, cvss_score_changed, ...restVal } = value;
        if (isNewVuln) {
          return isNewVuln;
        }
        return Object.values(restVal).every((val: any) => val);
      }
      if (key === "stepsToReproduce") {
        if (Array.isArray(value) && value.length > 0) {
          return value.length > 0 && value.every((step: Step) => step.file);
        }
      }

      return value;
    });

    const isValidSteps = steps.every((step: Step) => step.file);

    return isValidFormData && isValidSteps;
  }, [formData, defaultFormdata, steps, isAiaTenant, isNewVuln]);

  const enableNewStepBtn = useMemo(() => {
    if (steps.length === 0) return true;
    return steps.length > 0 && steps.every((step: Step) => step.file);
  }, [steps]);

  return (
    <div className="findingForm" onClick={(e: any) => e.stopPropagation()}>
      <MotifProgressLoader show={showSpinner} />
      <div className="accordionSectionHeader">
        <div className="accordionSectionHeader__title">
          Finding {index + 1} Details
        </div>
        <div className="accordionSectionHeader__description">
          Input all the details from your testing into the tool. After you've added all your findings, simply click on "Generate Report" to create the Word document. This process is quick and straightforward, ensuring you get your report ready with ease.
        </div>
        <div className="accordionSectionHeader__divider" />
      </div>
      <div className="findingForm__form" id="findingForm__form">
        <div ref={formRef}>
          <span>Select Vulnerability Category (required) </span>
          <MotifFormField className="clientDetails__formField">
            {formData.vulnerabilityCategory === "" && (
              <MotifLabel>Select Vulnerability Category</MotifLabel>
            )}
            <MotifSelect
              onChange={(e: any) => handleChange(e, "vulnerabilityCategory")}
              value={formData.vulnerabilityCategory}
              disabled={formEnabled}
              className={
                formData.vulnerabilityCategory !== "" && "value-selected"
              }
              onClick={handleFocus}
            >
              {vul_category_list.map((cat: any, indx: number) => (
                <MotifOption value={cat} key={indx}>
                  {cat}
                </MotifOption>
              ))}
            </MotifSelect>
          </MotifFormField>
        </div>
        <div className="findingForm__formField">
          <span className="left-element">
            <span>
              Select Vulnerability Name {" "}
              (required)
            </span>
            <MotifFormField
              className="clientDetails__formField"
              id="vulnerabilityName"
            >
              {formData.vulnerabilityName == "" && (
                <MotifLabel>Select Vulnerability Name</MotifLabel>
              )}
              {!isFirstDropdownOpen &&
              formData.vulnerabilityCategory !== "" &&
              Object.keys(vul_name_list).length > 0 &&
              vul_name_list[formData.vulnerabilityCategory]?.length > 0 ? (
                <MotifSelect
                  id="vulnerabilityName-select"
                  disabled={isFirstDropdownOpen}
                  value={vul_name_list[formData.vulnerabilityCategory]?.find(
                    (vulnName: any) => vulnName === formData.vulnerabilityName
                  )}
                  onChange={(e: any) => onSelecrVulnerabilityName(e)}
                  className={
                    formData.vulnerabilityName !== "" && "value-selected"
                  }
                >
                  {vul_name_list[formData.vulnerabilityCategory]?.map(
                    (vulnName: any, index: number) => (
                      <MotifOption value={vulnName} key={index}>
                        {vulnName}
                      </MotifOption>
                    )
                  )}
                  {/* {console.log(vul_name_list[formData.vulnerabilityCategory])} */}

                </MotifSelect>
              ) : (
                <MotifInput
                  id="vulnerabilityName-select"
                  value={
                    typeof formData.vulnerabilityName === "object"
                      ? ""
                      : formData.vulnerabilityName
                  }
                  disabled={true}
                  maxLength={MAX_INPUT_LENGTH}
                  hideClearButton
                />
              )}
            </MotifFormField>
          </span>
          <MotifButton
            size="medium"
            variant="text"
            type="button"
            className="right-element"
            disabled={
              formEnabled ||
              isFirstDropdownOpen ||
              formData.vulnerabilityCategory === ""
            }
            onClick={handleAddVulnerabilityName}
          >
            + Add Vulnerability Name
          </MotifButton>
        </div>
        {isAiaTenant && (
            <>
              <span className="left-element">
                <span>Port</span>
                <MotifFormField className="clientDetails__formField">
                  <MotifLabel>Port</MotifLabel>
                  <MotifInput
                    value={formData.port}
                    onChange={(e: any) => {
                      const rawValue = e?.target?.value ?? "";
                      const numericValue = rawValue.replace(/\D/g, "");
                      const maxPort = numericValue.slice(0, 5); // Limit to 5 digits (ports are 0-65535)
                      handleChange({ ...e, target: { ...e.target, value: maxPort } }, "port");
                    }}
                    disabled={formEnabled}
                    maxLength={5}
                  />
                </MotifFormField>
              </span>
              <span className="left-element">
                <span>CWE</span>
                <MotifFormField className="clientDetails__formField">
                  <MotifLabel>CWE</MotifLabel>
                  <MotifInput
                    value={formData.cwe}
                    onChange={(e: any) => handleChange(e, "cwe")}
                    disabled={formEnabled}
                    maxLength={MAX_INPUT_LENGTH}
                  />
                </MotifFormField>
              </span>
            </>
          )}
        <span>Description of Vulnerability (required)</span>
        <TextAreaWithButtons
          fieldName="vulnerabilityDescription"
          value={formData.vulnerabilityDescription}
          onChange={(e: any) => handleChange(e, "vulnerabilityDescription")}
          disabled={formEnabled}
          className={
            formData.vulnerabilityDescription !== "" && "value-available"
          }
          style={{ whiteSpace: "pre-wrap" }}
          maxLength={MAX_TEXTAREA_LENGTH}
          labelComponent={
            formData.vulnerabilityDescription === "" && (
              <MotifLabel>Please provide description of Vulnerability</MotifLabel>
            )
          }
          charCountLabel={`${formData?.vulnerabilityDescription?.length}/${MAX_TEXTAREA_LENGTH} characters remaining`}
          correctionData={correctionData}
          checkingInProgress={checkingInProgress}
          handleCheckAndCorrect={handleCheckAndCorrect}
          handleAcceptCorrection={handleAcceptCorrection}
          handleRetryCorrection={handleRetryCorrection}
          handleRejectCorrection={handleRejectCorrection}
          handleImprovedContentEdit={handleImprovedContentEdit}
          chatTickIcon={chatTickIcon}
          enableCheckAndCorrect={isCheckAndCorrectEnabled}
          errorComponent={
            isMaliciousInput(formData.vulnerabilityDescription || "") && (
              <MotifErrorMessage role="alert">
                {maliciousInputErrorMsg}
              </MotifErrorMessage>
            )
          }
        />
        <span>
          {isAiaTenant
            ? "Provide Affected Assets (required)"
            : "Provide Affected Instances (required)"}
        </span>
        <TextAreaWithButtons
          fieldName="affectedAssets"
          value={formData.affectedAssets}
          onChange={(e: any) => handleChange(e, "affectedAssets")}
          disabled={formEnabled}
          className={formData.affectedAssets !== "" && "value-available"}
          maxLength={MAX_TEXTAREA_LENGTH}
          labelComponent={
            formData.affectedAssets === "" && (
              <MotifLabel>
                {isAiaTenant
                  ? "Please provide Affected Assets"
                  : "Please provide Affected Instances"}
              </MotifLabel>
            )
          }
          charCountLabel={`${formData?.affectedAssets?.length}/${MAX_TEXTAREA_LENGTH} characters remaining`}
          correctionData={correctionData}
          checkingInProgress={checkingInProgress}
          handleCheckAndCorrect={handleCheckAndCorrect}
          handleAcceptCorrection={handleAcceptCorrection}
          handleRetryCorrection={handleRetryCorrection}
          handleRejectCorrection={handleRejectCorrection}
          handleImprovedContentEdit={handleImprovedContentEdit}
          chatTickIcon={chatTickIcon}
          enableCheckAndCorrect={isCheckAndCorrectEnabled && isAiaTenant}
          errorComponent={
            isMaliciousInput(formData.affectedAssets || "") && (
              <MotifErrorMessage role="alert">
                {maliciousInputErrorMsg}
              </MotifErrorMessage>
            )
          }
        />


        <span>
          {isAiaTenant ? "Provide Risks (required)" : "Provide impact (required)"}
        </span>
        <TextAreaWithButtons
          fieldName="impact"
          value={formData.impact}
          onChange={(e: any) => handleChange(e, "impact")}
          disabled={formEnabled}
          className={formData.impact !== "" && "value-available"}
          maxLength={MAX_TEXTAREA_LENGTH}
          labelComponent={
            formData.impact === "" && (
              <MotifLabel>
                {isAiaTenant ? "Please provide Risks" : "Please provide impact"}
              </MotifLabel>
            )
          }
          charCountLabel={`${formData?.impact?.length}/${MAX_TEXTAREA_LENGTH} characters remaining`}
          correctionData={correctionData}
          checkingInProgress={checkingInProgress}
          handleCheckAndCorrect={handleCheckAndCorrect}
          handleAcceptCorrection={handleAcceptCorrection}
          handleRetryCorrection={handleRetryCorrection}
          handleRejectCorrection={handleRejectCorrection}
          handleImprovedContentEdit={handleImprovedContentEdit}
          chatTickIcon={chatTickIcon}
          enableCheckAndCorrect={isCheckAndCorrectEnabled}
          errorComponent={
            isMaliciousInput(formData.impact || "") && (
              <MotifErrorMessage role="alert">
                {maliciousInputErrorMsg}
              </MotifErrorMessage>
            )
          }
        />
        
        <span>Provide Likelihood (required)</span>
        <TextAreaWithButtons
          fieldName="likelihoodType"
          value={formData.likelihoodType}
          onChange={(e: any) => handleChange(e, "likelihoodType")}
          disabled={formEnabled}
          className={formData.likelihoodType !== "" && "value-available"}
          maxLength={MAX_TEXTAREA_LENGTH}
          labelComponent={
            formData.likelihoodType === "" && (
              <MotifLabel>Please provide likelihood </MotifLabel>
            )
          }
          charCountLabel={`${formData?.likelihoodType?.length}/${MAX_TEXTAREA_LENGTH} characters remaining`}
          correctionData={correctionData}
          checkingInProgress={checkingInProgress}
          handleCheckAndCorrect={handleCheckAndCorrect}
          handleAcceptCorrection={handleAcceptCorrection}
          handleRetryCorrection={handleRetryCorrection}
          handleRejectCorrection={handleRejectCorrection}
          handleImprovedContentEdit={handleImprovedContentEdit}
          chatTickIcon={chatTickIcon}
          enableCheckAndCorrect={isCheckAndCorrectEnabled}
          errorComponent={
            isMaliciousInput(formData.likelihoodType || "") && (
              <MotifErrorMessage role="alert">
                {maliciousInputErrorMsg}
              </MotifErrorMessage>
            )
          }
        />
        {(formEnabled && formData.aiGeneratedContent !== undefined) ||
        (formData.isLoaded && isVulCategoryNameChanged === false) ? (
          <AIGeneratedContent
            formData={formData.aiGeneratedContent}
            findingId={formData?.id}
            handleFormChange={handleAIGeneratedDataChange}
          />
        ) : null}
        {isAiaTenant && (
          <div className="useCaseSection">
            <div className="useCaseSection__header">
              <div>
                <div className="useCaseSection__title">Use Cases</div>
                <div className="useCaseSection__description">
                  View and organize testing scenarios into use cases with detailed
                  steps. Editing is available only in the latest report versions.
                </div>
              </div>
              <MotifButton
                size="small"
                variant="primary"
                className="useCaseSection__action"
                onClick={handleAddUseCase}
                disabled={formEnabled}
              >
                <MotifIcon src={contentIcAdd24px} />
                Add Use Cases
              </MotifButton>
            </div>
            <div className="useCaseSection__divider" />
            {useCases.length === 0 ? (
              <div className="useCaseSection__emptyState">
                <div className="useCaseSection__emptyIconWrapper">
                  <img src={MultiPageAdd} alt="Use cases empty state" />
                </div>
                <div className="useCaseSection__emptyTitle">
                  No use cases added to this report
                </div>
                <div className="useCaseSection__emptyDescription">
                  This report doesn�t include any use cases. Add a use case to
                  connect findings and structure this report.
                </div>
              </div>
            ) : (
              <div className="useCaseAccordionList">
                  {useCases.map((useCase, useCaseIndex) => {
                    const isUseCaseOpen = openUseCaseIndex === useCaseIndex;
                    return (
                      <MotifAccordion
                        key={useCase.id}
                        alignIconLeft
                        useChevronIcon
                        open={isUseCaseOpen}
                        onOpen={() => setOpenUseCaseIndex(useCaseIndex)}
                        onClose={() => setOpenUseCaseIndex(prev => prev === useCaseIndex ? -1 : prev)}
                      >
                        <MotifAccordionTrigger>
                          <div className="useCaseAccordionTrigger">
                            <span className="useCaseAccordionTrigger__title">{useCase.title}</span>
                            <div className="useCaseAccordionTrigger__meta">
                              <span className="useCaseCard__stepBadge">
                                {useCase.isSaved ? useCase.steps.length : 0}{" "}
                                {useCase.isSaved && useCase.steps.length === 1 ? "Step" : "Steps"}
                              </span>
                              <MotifButton
                                size="small"
                                variant="text"
                                type="button"
                                className="useCaseCard__deleteUseCaseAction"
                                onClick={(e: any) => { e.stopPropagation(); handleDeleteUseCase(useCaseIndex); }}
                                disabled={formEnabled}
                              >
                                <MotifIcon
                                  src={actionIcDelete24px}
                                  style={{ width: 18, height: 18 }}
                                />
                              </MotifButton>
                            </div>
                          </div>
                        </MotifAccordionTrigger>
                        <MotifAccordionContent className="useCaseAccordionContent">
                          <div className="useCaseCard">
                            <div className="useCaseCard__top">
                              <div className="useCaseCard__titleGroup">
                                <MotifInput
                                  value={useCase.title}
                                  onChange={(e: any) =>
                                    handleUseCaseTitleChange(
                                      e?.target?.value || "",
                                      useCaseIndex
                                    )
                                  }
                                  disabled={
                                    formEnabled || editableUseCaseIndex !== useCaseIndex
                                  }
                                  placeholder="User Case Name"
                                  className="useCaseCard__titleInput"
                                  maxLength={MAX_INPUT_LENGTH}
                                />
                                {!useCase.isSaved ? (
                                  <MotifButton
                                    size="small"
                                    variant="text"
                                    type="button"
                                    className="useCaseCard__editAction"
                                    onClick={() => handleSaveUseCase(useCaseIndex)}
                                    disabled={formEnabled || isSavingUseCaseIndex === useCaseIndex}
                                  >
                                    {isSavingUseCaseIndex === useCaseIndex ? (
                                      <MotifIcon
                                        src={navigationIcRefresh24px}
                                        className="checking-loader"
                                        style={{ width: 16, height: 16 }}
                                      />
                                    ) : (
                                      <MotifIcon
                                        src={actionIcDone24px}
                                        style={{ width: 16, height: 16 }}
                                      />
                                    )}
                                    {isSavingUseCaseIndex === useCaseIndex ? "Saving..." : "Save"}
                                  </MotifButton>
                                ) : editableUseCaseIndex === useCaseIndex ? (
                                  useCase.useCaseApiId ? (
                                  <MotifButton
                                    size="small"
                                    variant="text"
                                    type="button"
                                    className="useCaseCard__editAction"
                                    onClick={() => handleUpdateUseCase(useCaseIndex)}
                                    disabled={formEnabled || isSavingUseCaseIndex === useCaseIndex}
                                  >
                                    {isSavingUseCaseIndex === useCaseIndex ? (
                                      <MotifIcon
                                        src={navigationIcRefresh24px}
                                        className="checking-loader"
                                        style={{ width: 16, height: 16 }}
                                      />
                                    ) : (
                                      <MotifIcon
                                        src={actionIcDone24px}
                                        style={{ width: 16, height: 16 }}
                                      />
                                    )}
                                    {isSavingUseCaseIndex === useCaseIndex ? "Updating..." : "Update"}
                                  </MotifButton>
                                  ) : (
                                  <MotifButton
                                    size="small"
                                    variant="text"
                                    type="button"
                                    className="useCaseCard__editAction"
                                    onClick={() => handleSaveUseCase(useCaseIndex)}
                                    disabled={formEnabled || isSavingUseCaseIndex === useCaseIndex}
                                  >
                                    {isSavingUseCaseIndex === useCaseIndex ? (
                                      <MotifIcon
                                        src={navigationIcRefresh24px}
                                        className="checking-loader"
                                        style={{ width: 16, height: 16 }}
                                      />
                                    ) : (
                                      <MotifIcon
                                        src={actionIcDone24px}
                                        style={{ width: 16, height: 16 }}
                                      />
                                    )}
                                    {isSavingUseCaseIndex === useCaseIndex ? "Saving..." : "Save"}
                                  </MotifButton>
                                  )
                                ) : (
                                  <MotifButton
                                    size="small"
                                    variant="text"
                                    type="button"
                                    className="useCaseCard__editAction"
                                    onClick={() => setEditableUseCaseIndex(useCaseIndex)}
                                    disabled={formEnabled}
                                  >
                                    <MotifIcon
                                      src={imageIcEdit24px}
                                      style={{ width: 16, height: 16 }}
                                    />
                                    Edit
                                  </MotifButton>
                                )}
                              </div>
                            </div>
                            <div className="useCaseCard__divider" />
                            {useCase.steps.length === 0 && (
                              <div className="useCaseCard__emptySteps">
                                No steps yet
                              </div>
                            )}
                            {useCase.isSaved && useCase.steps.map((useCaseStep, stepIndex) => (
                              <div className="useCaseStepCard" key={useCaseStep.id}>
                                <div className="useCaseStepCard__header">
                                  <div className="useCaseStepCard__title">
                                    Step{" "}
                                    <span className="useCaseStepCard__stepNumber">
                                      {stepIndex + 1}
                                    </span>
                                  </div>
                                  <MotifButton
                                    size="small"
                                    variant="text"
                                    type="button"
                                    className="useCaseStepCard__deleteAction"
                                    onClick={() =>
                                      handleDeleteUseCaseStep(useCaseIndex, stepIndex)
                                    }
                                    disabled={formEnabled}
                                  >
                                    - Delete Step
                                  </MotifButton>
                                </div>
                                <MotifFormField className="useCaseStepCard__field">
                                  <MotifTextArea
                                    value={useCaseStep.description}
                                    onChange={(e: any) =>
                                      handleUseCaseStepDescriptionChange(
                                        e?.target?.value || "",
                                        useCaseIndex,
                                        stepIndex
                                      )
                                    }
                                    disabled={formEnabled}
                                    placeholder="Description (required)"
                                    className={
                                      useCaseStep.description ? "value-available" : ""
                                    }
                                    maxLength={MAX_TEXTAREA_LENGTH}
                                  />
                                </MotifFormField>
                                <span className="useCaseStepCard__uploadTitle">
                                  Provide screenshots
                                </span>
                                {useCaseStep.uploadedImages.map((image, imageIndex) => (
                                  <div key={image.id} className="useCaseStepCard__imageSlot">
                                    <div className="uploadImage">
                                      {image.imageLink && (
                                        <div className="previewButton">
                                          <MotifButton
                                            className="box"
                                            onClick={() => previewImage(image.imageLink as any)}
                                            type="button"
                                            variant="secondary"
                                          >
                                            Preview
                                          </MotifButton>
                                        </div>
                                      )}
                                      <MotifFileUploaderItem
                                        aria-label="Item aria-label text"
                                        fileIcon={
                                          <MotifIcon src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQgMkg2Yy0xLjEgMC0xLjk5LjktMS45OSAyTDQgMjBjMCAxLjEuODkgMiAxLjk5IDJIMThjMS4xIDAgMi0uOSAyLTJWOGwtNi02em0yIDE2SDh2LTJoOHYyem0wLTRIOHYtMmg4djJ6bS0zLTVWMy41TDE4LjUgOUgxM3oiLz48L3N2Zz4=" />
                                        }
                                        fileName={image.imageLabel || image.file?.name}
                                        fileSize={image.file?.size}
                                        id={String(image.id)}
                                        onRemove={() =>
                                          handleUseCaseImageRemove(
                                            useCaseIndex,
                                            stepIndex,
                                            imageIndex
                                          )
                                        }
                                        removable={true}
                                        uploaded
                                        percentUploaded={100}
                                        uploadedText="100% completed"
                                        disabled={formEnabled}
                                      />
                                    </div>
                                    <div className="useCaseStepCard__captionWrapper">
                                      <MotifFormField className="useCaseStepCard__captionField">
                                        <MotifTextArea
                                          value={image.caption}
                                          onChange={(e: any) =>
                                            handleUseCaseImageCaptionChange(
                                              e?.target?.value || "",
                                              useCaseIndex,
                                              stepIndex,
                                              imageIndex
                                            )
                                          }
                                          disabled={formEnabled}
                                          placeholder="Add image caption..."
                                          maxLength={MAX_TEXTAREA_LENGTH}
                                          className={image.caption ? "value-available" : ""}
                                        />
                                      </MotifFormField>
                                      <span className="useCaseStepCard__captionCount">
                                        {image.caption.length}/{MAX_TEXTAREA_LENGTH}
                                      </span>
                                    </div>
                                  </div>
                                ))}
                                {useCaseStep.showUploader && (
                                  <>
                                    {useCaseStep.isUploading ? (
                                      <div className="useCaseStepCard__uploadingState">
                                        <MotifProgressLoader show={true} />
                                        <span>Uploading image...</span>
                                      </div>
                                    ) : (
                                      <MotifFileUploader
                                        className="useCaseStepCard__fileUploader"
                                        accept={[".png", ".jpeg", ".jpg"]}
                                        maxSize={500}
                                        id={`use_case_file_uploader_${useCase.id}_${stepIndex}`}
                                        label={
                                          <div className="useCaseStepCard__uploaderLabel">
                                            <div className="useCaseStepCard__uploaderLabelMain">
                                              <b>Click to upload screenshots</b> or drag and drop
                                            </div>
                                            <p className="useCaseStepCard__uploaderLabelSub">
                                              PNG or JPG (max. 500kb per file)
                                            </p>
                                          </div>
                                        }
                                        onDrop={(payload: any) =>
                                          handleUseCaseScreenshotUpload(
                                            payload,
                                            useCaseIndex,
                                            stepIndex
                                          )
                                        }
                                        disabled={formEnabled}
                                        error={!!useCaseStep.isUploadError}
                                      />
                                    )}
                                    {useCaseStep.isUploadError && (
                                      <MotifErrorMessage role="alert">
                                        File size should not exceed 500KB
                                      </MotifErrorMessage>
                                    )}
                                  </>
                                )}
                                {!useCaseStep.showUploader && (
                                  <MotifButton
                                    size="small"
                                    variant="text"
                                    type="button"
                                    className="useCaseStepCard__addImageAction"
                                    onClick={() =>
                                      handleShowUseCaseUploader(useCaseIndex, stepIndex)
                                    }
                                    disabled={formEnabled}
                                  >
                                    <MotifIcon
                                      src={imageIcAddToPhotos24px}
                                      style={{ width: 16, height: 16, color: "#1a73e8", fill: "#1a73e8" }}
                                    />
                                    Add Image
                                  </MotifButton>
                                )}
                              </div>
                            ))}
                            <MotifButton
                              size="small"
                              variant="secondary"
                              className="useCaseCard__addStepAction"
                              onClick={() => handleAddUseCaseStep(useCaseIndex)}
                              disabled={formEnabled || !useCase.isSaved}
                            >
                              <MotifIcon src={contentIcAdd24px} />
                              Add Step
                            </MotifButton>
                          </div>
                        </MotifAccordionContent>
                      </MotifAccordion>
                    );
                  })}
              </div>
            )}
          </div>
        )}
        {!isAiaTenant && (
          <>
            <div className="clientDetails__title">Steps to Reproduce</div>
            <div>
              Input all the details from your testing into the tool. After you've
              added all your findings, simply click on "Generate Report" to create
              the Word document. This process is quick and straightforward, ensuring
              you get your report ready with ease.
            </div>
            {steps.map((step, index) => {
              return (
                <div style={{ marginTop: "20px" }}>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Step {index + 1} Description</span>
                    <MotifButton
                      size="small"
                      variant="text"
                      type="button"
                      onClick={() => {
                        handleDeleteStep(index, {
                          step_id: step?.step_id,
                          finding_id: finding?.finding_id,
                        });
                      }}
                    >
                      <MotifIcon src={actionIcDelete24px} style={{ width: 20 }} />
                    </MotifButton>
                  </span>
                  <MotifFormField>
                    {!step?.step_description && (
                      <MotifLabel>Please provide step description</MotifLabel>
                    )}
                    <TextAreaWithButtons
                      fieldName={`step_description_${index}`}
                      value={step?.step_description}
                      onChange={(e: any) =>
                        updateSteps(e, index, "step_description")
                      }
                      disabled={formEnabled}
                      className={step?.step_description && "value-available"}
                      maxLength={MAX_TEXTAREA_LENGTH}
                      labelComponent={null}
                      charCountLabel={`${step?.step_description.length}/${MAX_TEXTAREA_LENGTH} characters remaining`}
                      correctionData={correctionData}
                      checkingInProgress={checkingInProgress}
                      handleCheckAndCorrect={handleCheckAndCorrect}
                      handleAcceptCorrection={handleAcceptCorrection}
                      handleRetryCorrection={handleRetryCorrection}
                      handleRejectCorrection={handleRejectCorrection}
                      handleImprovedContentEdit={handleImprovedContentEdit}
                      chatTickIcon={chatTickIcon}
                      enableCheckAndCorrect={isCheckAndCorrectEnabled}
                      errorComponent={null}
                    />
                  </MotifFormField>
                  <span>Image Caption</span>
                  <MotifFormField>
                    {!step?.image_caption && (
                      <MotifLabel>Please provide an image caption</MotifLabel>
                    )}
                    <TextAreaWithButtons
                      fieldName={`image_caption_${index}`}
                      value={step?.image_caption}
                      onChange={(e: any) => updateSteps(e, index, "image_caption")}
                      disabled={formEnabled}
                      className={step?.image_caption && "value-available"}
                      maxLength={MAX_TEXTAREA_LENGTH}
                      labelComponent={null}
                      charCountLabel={`${step?.image_caption.length}/${MAX_TEXTAREA_LENGTH} characters remaining`}
                      correctionData={correctionData}
                      checkingInProgress={checkingInProgress}
                      handleCheckAndCorrect={handleCheckAndCorrect}
                      handleAcceptCorrection={handleAcceptCorrection}
                      handleRetryCorrection={handleRetryCorrection}
                      handleRejectCorrection={handleRejectCorrection}
                      handleImprovedContentEdit={handleImprovedContentEdit}
                      chatTickIcon={chatTickIcon}
                      enableCheckAndCorrect={isCheckAndCorrectEnabled}
                      errorComponent={
                        isMaliciousInput(step?.image_caption || "") && (
                          <MotifErrorMessage role="alert">
                            {maliciousInputErrorMsg}
                          </MotifErrorMessage>
                        )
                      }
                    />
                  </MotifFormField>

                  <span>Provide Screenshots (required)</span>
                  {!step?.file ? (
                    <>
                      <MotifFileUploader
                        accept={[".png", ".jpeg", ".jpg"]}
                        maxSize={100}
                        id={"file_uploader"}
                        label={
                          <div>
                            <div onClick={(event: any) => event.preventDefault()}>
                              <b>Click to Upload Screenshots</b> or drag and drop
                            </div>
                            <p>PNG or JPG (max. 1920X1080)</p>
                          </div>
                        }
                        onDrop={(e: React.DragEvent<HTMLDivElement>) =>
                          uploadFile(e, index, { step_id: step?.step_id })
                        }
                        error={step?.file && step?.file?.size > 100}
                        disabled={formEnabled}
                      ></MotifFileUploader>
                      {step?.isError && (
                        <MotifErrorMessage role="alert">
                          {" "}
                          {FILE_SIZE_ERROR_MSG}{" "}
                        </MotifErrorMessage>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="uploadImage">
                        <div className="previewButton">
                          <MotifButton
                            className="box"
                            onClick={() => {
                              previewImage(step.encoded_image);
                            }}
                            type="button"
                            variant="secondary"
                          >
                            Preview
                          </MotifButton>
                        </div>
                        <MotifFileUploaderItem
                          aria-label="Item aria-label text"
                          fileIcon={
                            <MotifIcon src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQgMkg2Yy0xLjEgMC0xLjk5LjktMS45OSAyTDQgMjBjMCAxLjEuODkgMiAxLjk5IDJIMThjMS4xIDAgMi0uOSAyLTJWOGwtNi02em0yIDE2SDh2LTJoOHYyem0wLTRIOHYtMmg4djJ6bS0zLTVWMy41TDE4LjUgOUgxM3oiLz48L3N2Zz4=" />
                          }
                          fileName={step?.file?.name}
                          fileSize={step?.file?.size}
                          id="2"
                          onRemove={() => removeFile(index, step?.step_id)}
                          removable={true}
                          uploaded
                          percentUploaded={100}
                          uploadedText="100% completed"
                          disabled={formEnabled}
                        />
                      </div>
                      {/* <div className="caption">
                  <MotifFormField>
                      <MotifLabel>{!step?.caption ? 'Please provide the image caption': 'Image Caption'}</MotifLabel>
                      <MotifTextArea
                        value={step?.caption}
                        onChange={(e: any) => updateSteps(e, index, 'caption')}
                        disabled={formEnabled}
                      />
                  </MotifFormField>
                  </div> */}
                    </>
                  )}
                </div>
              );
            })}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <MotifButton
                size="medium"
                variant="secondary"
                onClick={addSteps}
                disabled={!enableNewStepBtn}
              >
                <MotifIcon src={contentIcAdd24px} />
                Add Next Step
              </MotifButton>
            </div>
          </>
        )}
        {/* A
        <pre>{JSON.stringify({formData, steps}, null, 2)}</pre> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <MotifButton
            size="medium"
            variant="text"
            onClick={() => {
              setFormData(defaultFormdata);
              setSteps(defaultSteps);
              setUseCases(getUseCasesFromFinding(finding));
              setOpenUseCaseIndex(-1);
              setEditableUseCaseIndex(null);
            }}
            disabled={formEnabled || !formData.isModified}
          >
            <MotifIcon src={navigationIcRefresh24px} />
            Reset Finding
          </MotifButton>
          {finding.isLoaded ? (
            <MotifButton
              size="medium"
              variant="primary"
              onClick={() => {
                if (isAiaTenant) {
                  handleUpdateFinding({ ...formData, aiaUseCases: useCases }, index);
                } else {
                  handleUpdateFinding(formData, index);
                }
              }}
              disabled={formEnabled || !formData.isModified}
            >
              <MotifIcon src={contentIcSave24px} />
              Update Finding
            </MotifButton>
          ) : (
            <MotifButton
              size="medium"
              variant="primary"
              onClick={() => {
                if (isAiaTenant) {
                  const aiaSteps: any[] = [];
                  useCases.forEach((uc) => {
                    uc.steps.forEach((step, stepIdx) => {
                      if (step.uploadedImages.length > 0) {
                        step.uploadedImages.forEach((img) => {
                          aiaSteps.push({
                            encoded_image: "",
                            image_caption: img.caption || "",
                            image_id: String(img.id),
                            image_label: "",
                            step_description: "",
                            step_id: step.stepApiId,
                            step_number: stepIdx + 1,
                          });
                        });
                      }
                    });
                  });
                  handleGenerateFinding({ ...formData, aiaSteps });
                } else {
                  handleGenerateFinding(formData);
                }
              }}
              disabled={formEnabled || !isEnableFindingBtn}
            >
              <MotifIcon src={contentIcSave24px} />
              Generate Finding
            </MotifButton>
          )}
        </div>
      </div>
      <AddVunerabilityModal
        visibility={vulModal}
        setVisibility={() => handleVisibility()}
        onAdd={(e: any) => {
          onAddVulnerabilityName(e);
        }}
        errorMsg={addVulError}
        vulnerabilityDuplicateErrMsg={vulnerabilityDuplicateErrMsg}
        setvulnerabilityDuplicateErrMsg={setvulnerabilityDuplicateErrMsg}
      />
      {preview && (
        //TODO: Will Refer Motif Component once issue resolved
        // <>
        //   <MotifModal show={preview} onClose={() => setPreview(false)}>
        //     <MotifModalHeader className="files-preview-modal-header">
        //       {"Header"}
        //     </MotifModalHeader>
        //     <MotifModalBody>
        //       {userFile && <ImagePreview file={userFile} />}
        //       {/* Hidden input to ensure focusable element */}
        //       <input
        //         type="text"
        //         style={{
        //           position: "absolute",
        //           opacity: 0,
        //           height: 0,
        //           width: 0,
        //         }}
        //         tabIndex={0}
        //       />
        //     </MotifModalBody>
        //     <MotifModalFooter>
        //       <MotifButton
        //         size="medium"
        //         variant="primary"
        //         onClick={() => setPreview(false)}
        //       >
        //         Cancel
        //       </MotifButton>
        //       <MotifButton
        //         size="medium"
        //         variant="primary"
        //         onClick={() => setPreview(false)}
        //       >
        //         close
        //       </MotifButton>
        //     </MotifModalFooter>
        //   </MotifModal>
        // </>

        //Here using CustomModal to display image preview
        <div className="preview-modal">
          <CustomModal show={preview} onClose={() => setPreview(null)}>
            {typeof preview === "string" && (
              <div>
                {(preview as string).startsWith("http") || (preview as string).startsWith("/") ? (
                  <img src={preview as string} alt="Preview" style={{ maxWidth: "100%" }} />
                ) : (
                  <img src={`data:image/jpeg;base64,${preview}`} alt="Preview" />
                )}
              </div>
            )}
            {/* Hidden input to ensure focusable element */}
            <input
              type="text"
              style={{ position: "absolute", opacity: 0, height: 0, width: 0 }}
              tabIndex={-1}
            />
          </CustomModal>
        </div>
      )}
      <Toast
        visible={toastVisible}
        setVisible={setToastVisible}
        children={
          <div>
            <div className={"toastHeader"}>{toastData?.header}</div>
            <div className={"toastContent"}>{toastData?.message}</div>
          </div>
        }
        variant={toastData?.variant}
      />
    </div>
  );
};

export default FindingForm;
